

import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import Navigation from 'vue-navigation'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import DrawerLayouts from 'vue-drawer-layout'
import axios from 'axios'
import VCharts from 'v-charts'
import dateFormat from './filters/dateFormat'
import dateFormatf from './filters/dateFormat_f'
import maxLength from './filters/maxLength'
import maxLength20 from './filters/maxLength_20'
import maxLength15 from './filters/maxLength_15'
import strReplace from './filters/strreplace'
import spaceReplace from './filters/spaceReplace'
import GoodsInfoBottom from '@/components/common/GoodsInfoBottom'
import HSBottom from '@/components/common/HSBottom'
import NavGrid from '@/components/common/NavGrid'
import NavTradeGrid from '@/components/common/NavTradeGrid'
import myMarquee from '@/components/common/my-marquee'
import GoodWizard from '@/components/common/Wizard'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(VCharts)
Vue.use(ElementUI)
Vue.prototype.$http = axios







axios.defaults.baseURL = 'https://data.customskb.com'


window.setBaseURL = function (url) {
axios.defaults.baseURL = url
}
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(DrawerLayouts)
Vue.filter('dateFormat', dateFormat)
Vue.filter('spaceReplace', spaceReplace)
Vue.filter('dateFormatf', dateFormatf)
Vue.filter('maxLength', maxLength)
Vue.filter('maxLength20', maxLength20)
Vue.filter('maxLength15', maxLength15)
Vue.filter('strReplace', strReplace)
Vue.component('gi-bottom', GoodsInfoBottom)
Vue.component('my-marquee', myMarquee)
Vue.component('hs-bottom', HSBottom)
Vue.component('nav-grid', NavGrid)
Vue.component('nav-trade-grid', NavTradeGrid)
Vue.component(GoodWizard.name, GoodWizard)

Vue.use(Navigation, {router})
/* eslint-disable no-new */

Vue.filter('dataNullFilter', function (value) {
if (!value || value.toLowerCase().trim() === 'null') {
return ''
}
return value
})
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js